import { Modal, Progress, Stack, Text } from '@mantine/core';

type Props = {
  opened: boolean;
  close: () => void;
  completed: number;
  total: number;
};

export function UploadProgressModal({ opened, close, completed, total }: Props) {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <Modal opened={opened} onClose={close} title="Uploading files" size="sm">
      <Stack gap="md">
        <Text size="sm">
          Uploaded {completed} of {total} files
        </Text>
        <Progress value={percentage} size="lg" radius="md" color="brand.6" />
        <Text size="xs" c="dimmed">
          You can close this dialog without interrupting your data upload.
        </Text>
      </Stack>
    </Modal>
  );
}
